export interface AddShippingReferenceNumberToShippingNote {
	id: number;
	shippingReferenceNumber: string;
}

export class AddShippingReferenceNumberToShippingNote implements AddShippingReferenceNumberToShippingNote {	
	constructor(data?: Partial<AddShippingReferenceNumberToShippingNote>) {
		if (data) {
			for (const key of Object.keys(data)) {
				(this as any)[key] = (data as any)[key];
			}
		}
	}
}